import { isStudioModuleEntitled } from "./studioModules";

export const isGeoEnabled = (): boolean =>
  process.env.REACT_APP_GEO_ENABLED === "true" ||
  process.env.REACT_APP_ENV === "loc";

export const canUseGiRegistry = (role?: string): boolean => {
  if (!isGeoEnabled() || !role) {
    return false;
  }
  const allowed =
    role === "SUPER_ADMIN" ||
    role === "ORGANIZATION_ADMIN" ||
    role === "ORGANIZATION_MANAGER";
  if (!allowed) {
    return false;
  }
  if (role === "SUPER_ADMIN") {
    return true;
  }
  return isStudioModuleEntitled("GEO");
};
